import { render, staticRenderFns } from "./ProductItemCreation.vue?vue&type=template&id=d2761e38&scoped=true"
import script from "./ProductItemCreation.vue?vue&type=script&lang=js"
export * from "./ProductItemCreation.vue?vue&type=script&lang=js"
import style0 from "./ProductItemCreation.vue?vue&type=style&index=0&id=d2761e38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2761e38",
  null
  
)

export default component.exports